import { BoneTypeEnum, DeviceEnum, PlanTypeEnum, SearchItems } from '../core';
import { anatomicalSideTranslate, boneTypeTranslate, deviceTranslate, planStepTranslate, planTypeTranslate } from '../shared';


/**
 * Extended interface for SearchItems with additional properties.
 */
export interface ExtendedSearchItems extends SearchItems {
	opened?: boolean;
	displayDevice?: string;
	displayPlanStep?: string;
	displayPlanType?: string;
	displayBoneType?: string;
	displaySide?: string;
	displayScenario?: string;
}

/**
 * Mapper function to convert SearchItems to ExtendedSearchItems.
 */
export const extendedSearchItemsMapper = (item: SearchItems, labels: any): ExtendedSearchItems => {
	return {
		...item,
		opened: false,
		displayDevice: item.device ? deviceTranslate(item.device, labels) : '',
		displayPlanStep: item.step ? planStepTranslate(item.step, labels) : '',
		displayPlanType: item.caseType ? planTypeTranslate(item.caseType, labels) : '',
		displayBoneType: item.boneType ? boneTypeTranslate(item.boneType, labels) : '',
		displaySide: item.caseSide ? anatomicalSideTranslate(item.caseSide, labels) : '',
		displayScenario: item.isPostOperative ? 'PostOp' : 'PreOp'
	}
}

export const deviceListFilter = (item: SearchItems | null, isJps?: boolean, isFitbone?: boolean, isTlhex?: boolean) => {
	const list: DeviceEnum[] = [];
	if (!item) return list;
	if (isTlhex && ((item.caseAPImagesGuid && item.caseLTImagesGuid) || (!item.caseAPImagesGuid && !item.caseLTImagesGuid))) {
		list.push(DeviceEnum.Tlhex);
	}
	if (isFitbone && (item.caseAPImagesGuid && !item.isPostOperative && item.caseType === PlanTypeEnum.Deformity && item.boneType === BoneTypeEnum.LongLeg)) {
		list.push(DeviceEnum.Fitbone);
	}
	if (isJps && ((item.caseAPImagesGuid || item.caseLTImagesGuid) && !item.isPostOperative && item.caseType === PlanTypeEnum.Deformity && [BoneTypeEnum.LongLeg, BoneTypeEnum.Femur, BoneTypeEnum.Tibia].includes(item.boneType!))) {
		list.push(DeviceEnum.Jps);
	}
	return list;
}